import React, { useContext } from 'react'
import { useState } from 'react'
import {useSignup} from '../hooks/useSignup'
import '../store.css'
import { CartContext } from '../../context/CartContext'

import { Link, useNavigate } from 'react-router-dom'

export default function Signup() {

    const [email,setEmail] = useState('')
    const [password,setPassword] = useState('')
    const {cartItems} = useContext(CartContext)
    const navigate = useNavigate()

    const {error,isloading,signup} = useSignup();

    const handleSubmit = async (e) => {
        e.preventDefault();
   const success  = await signup(email,password);
    if(success) {
        !cartItems ? console.log("No cart items"): console.log(" cart items")
    }
  }
  return (
    <form className='signup' onSubmit={handleSubmit}>
        <h2>Sign Up</h2>
        <label >Email:</label>
        <input type='email' value={email} onChange={(e) => setEmail(e.target.value)} />
        <label >Password:</label>
        <input type='password' value={password} onChange={(e) => setPassword(e.target.value)} />

        <button disabled={isloading}>Sign Up</button>
        <h4>Already have an account? <Link to="/loginuser">Login</Link></h4>
        {error && <div className='error'>{error}</div>}
    </form>
  )
}
